import {
  SET_WP_MINE_PAY_LIST,
  SET_WP_MINE_SETUP_LIST,
  SET_WP_MINE_COLLECT_LIST,
  CANCEL_WP_MINE_COLLECTORSETUP,
  SET_WP_VIP_STATE,
  SET_WP_TURN_LIST,
  CANCEL_MINE_TURN,
  OPEN_GROUP_LIST,
  SET_WP_GROUP_LIST,
  SET_CHOICE_LIST,
  SET_EQUITY_VIP,
  WP_IS_NEED_UPDATE_VIP,
  SET_SHOW_LIST,
  SET_SHOW_WP_EXCHANGE,
  SET_WP_EXCHANGE_RESULT,
  SET_SHOW_WP_RESULT,
} from '../constants/wallpaperPay';

const initState = {
  minePayInfo: {
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
      tagId: 'paylist',
    },
    list: [],
    load: false,
  },
  mineSetupInfo: {
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
      tagId: 'setup',
    },
    allData: [],
    list: [],
    load: false,
  },
  mineCollectInfo: {
    pagenation: {
      skip: 0,
      limit: 48,
      count: 0,
      tagId: 'collect',
    },
    allData: [],
    list: [],
    load: false,
  },
  vipState: {
    vipState: 0,
    vipExpireTime: '',
    vipFixTimeChargeState: 1,
  },
  mineTurnInfo: {
    pagenation: {
      tagId: 'turn',
    },
    allData: [],
    list: [],
    validCarouselList: [],
    invalidCarouselList: [],
    load: false,
    pageCursor: '',
    hasNextPage: false,
  },
  openGroupList: false,
  groupList: {
    load: false,
    list: [],
    setup: {},
    collect: {},
    choiceList: [],
  },
  isUpdateVip: 1,
  loopTimeShow: false,
  exchangeShow: false,
  exchangeResult: {
    isShow: false,
  },
};

const wallpaperPay = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_WP_MINE_PAY_LIST:
      return {
        ...state,
        minePayInfo: {
          ...state.minePayInfo,
          ...action.payload,
        },
      };
    case SET_WP_MINE_SETUP_LIST:
      return {
        ...state,
        mineSetupInfo: {
          ...state.mineSetupInfo,
          ...action.payload,
        },
      };
    case SET_WP_MINE_COLLECT_LIST:
      return {
        ...state,
        mineCollectInfo: {
          ...state.mineCollectInfo,
          ...action.payload,
        },
      };
    case CANCEL_WP_MINE_COLLECTORSETUP:
      if (action.payload.type === 4) {
        return {
          ...state,
          mineSetupInfo: {
            ...state.mineSetupInfo,
            list: state.mineSetupInfo.list.filter(
              item => item.wallpaperId !== action.payload.wallpaperId,
            ),
            pagenation: {
              ...state.mineSetupInfo.pagenation,
              count:
                state.mineSetupInfo.pagenation.count - 1 > 0
                  ? state.mineSetupInfo.pagenation.count - 1
                  : 0,
            },
          },
        };
      } else {
        return {
          ...state,
          mineCollectInfo: {
            ...state.mineCollectInfo,
            list: state.mineCollectInfo.list.filter(
              item => item.wallpaperId !== action.payload.wallpaperId,
            ),
            pagenation: {
              ...state.mineCollectInfo.pagenation,
              count:
                state.mineCollectInfo.pagenation.count - 1 > 0
                  ? state.mineCollectInfo.pagenation.count - 1
                  : 0,
            },
          },
        };
      }

    case SET_WP_VIP_STATE:
      return {
        ...state,
        vipState: action.payload,
      };
    case SET_WP_TURN_LIST:
      return {
        ...state,
        mineTurnInfo: {
          ...state.mineTurnInfo,
          ...action.payload,
        },
      };
    case CANCEL_MINE_TURN:
      return {
        ...state,
        mineTurnInfo: {
          ...state.mineTurnInfo,
          // list: newList,
          allData: state.mineTurnInfo?.allData?.filter(e => {
            if (action.payload.parmas.wallpaperId) {
              return e?.wallpaperId !== action.payload.parmas.wallpaperId;
            } else {
              return e;
            }
          }),
          invalidCarouselList: state.mineTurnInfo?.invalidCarouselList?.filter(e => {
            if (action.payload.parmas.wallpaperId) {
              return e?.wallpaperInfo?.wallpaperId !== action.payload.parmas.wallpaperId;
            } else {
              return e.contentId !== action.payload.parmas.contentId;
            }
          }),
          validCarouselList: state.mineTurnInfo?.validCarouselList?.filter(e => {
            if (action.payload.parmas.wallpaperId) {
              return e?.wallpaperInfo?.wallpaperId !== action.payload.parmas.wallpaperId;
            } else {
              return e.contentId !== action.payload.parmas.contentId;
            }
          }),
        },
      };

    case OPEN_GROUP_LIST:
      return {
        ...state,
        openGroupList: action.payload,
      };
    case SET_WP_GROUP_LIST:
      return {
        ...state,
        groupList: { ...action.payload },
      };
    case SET_CHOICE_LIST:
      let setList = state.groupList.choiceList;
      if (action.payload.has === 0) {
        setList = setList.filter(
          item =>
            !(
              item.contentId === action.payload.item.contentId &&
              item.groupType === action.payload.item.groupType
            ),
        );
      } else {
        setList.push(action.payload.item);
      }
      return {
        ...state,
        groupList: {
          ...state.groupList,
          choiceList: setList,
        },
      };

    case SET_EQUITY_VIP:
      return {
        ...state,
        vipState: {
          vipState: 0,
          vipExpireTime: '',
          vipFixTimeChargeState: 0,
        },
      };
    case WP_IS_NEED_UPDATE_VIP:
      return {
        ...state,
        isUpdateVip: state.isUpdateVip + (action.payload || 1),
      };

    case SET_SHOW_LIST:
      return {
        ...state,
        loopTimeShow: action.payload,
      };
    case SET_SHOW_WP_EXCHANGE:
      return {
        ...state,
        exchangeShow: action.payload,
      };
    case SET_WP_EXCHANGE_RESULT:
      return {
        ...state,
        exchangeResult: {
          resultCode: action.payload?.resultCode,
          isShow: true,
        },
        exchangeShow: action.payload?.resultCode ? false : state.exchangeShow,
      };
    case SET_SHOW_WP_RESULT:
      return {
        ...state,
        exchangeResult: {
          ...state.exchangeResult,
          isShow: action.payload,
        },
      };
    default:
      return state;
  }
};
export default wallpaperPay;
